
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/court/[id]",
      function () {
        return require("private-next-pages/court/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/court/[id]"])
      });
    }
  